module.exports = {
  returnName: {
    1: 'Adm',
    2: 'ContratanteConsulta',
    3: 'ContratanteAlteracao',
  },
  returnNameForName: {
    Adm: 'Adm',
    ContratanteConsulta: 'ContratanteConsulta',
    ContratanteAlteracao: 'ContratanteAlteracao',
  },
  returnNameForRefresh: {
    Adm: 'ADM',
    ContratanteConsulta: 'contratante',
    ContratanteAlteracao: 'contratante',
  },

  returnNameFormatted: {
    0: 'Selecione',
    1: 'Administrador',
    2: 'Contratante Consulta',
    3: 'Contratante Alteração',
  },
  returnId: {
    Adm: 1,
    ContratanteConsulta: 2,
    ContratanteAlteracao: 3,
  },
  returnNameFormattedForName: {
    Selecione: 'Selecione',
    Adm: 'Administrador',
    Administrador: 'Administrador',
    ContratanteConsulta: 'Contratante Consulta',
    ContratanteAlteracao: 'Contratante Alteração',
  },
  returnNameForNameFormatted: {
    Administrador: 'Adm',
    'Contratante Consulta': 'ContratanteConsulta',
    'Contratante Alteração': 'ContratanteAlteracao',
  },
  returnTipoPerfilAcessoForTipoPerfil: {
    Selecione: 'Selecione',
    Adm: 'Administrador',
    Administrador: 'Administrador',
    Contratante: 'Contratante',
    ContratanteConsulta: 'Contratante',
    ContratanteAlteracao: 'Contratante',
  },
  // returnTipoPerfilForTipoPerfilAcesso: {
  //     Administrador: 'Administrador',
  //     Contratante: 'ContratanteConsulta',
  //     Contratante: 'ContratanteAlteração',
  // },
};
